module.exports = __webpack_public_path__ + "img/0.1258afbc.jpg";